


















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

import { ACTIVITY_TYPE } from '@/common/constants';
import fetch from '@/common/api/fetch';
import { AxiosPromiseData } from '@/common/interface';

import NoticeModal from '@/components/common/edit/NoticeModal.vue';
import MaterialModal from '@/components/common/index/MaterialModal.vue';
import InvalidModal from '@/components/common/index/InvalidModal.vue';
import CheckXmPayModal from '@/components/common/edit/CheckXmPayModal.vue';
import CONFIG from '@/common/config';
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';

@Component({
  components: {
    'notice-modal': NoticeModal,
    'material-modal': MaterialModal,
    'invalid-modal': InvalidModal,
    'check-modal': CheckXmPayModal
  }
})
export default class App extends Vue {
  @Getter('hasMaterialSaved') hasMaterialSaved!: boolean;
  @Getter('showFooter') showFooter!: boolean;
  @Getter('showInValidModal') showInValidModal!: boolean;
  @Getter('wechatMiniOnlineStatus') wechatMiniOnlineStatus!: string;
  @Getter('xmPayRegisterStatusEnum') xmPayRegisterStatusEnum!: string;

  showNotice: boolean = false;
  showMaterial: boolean = false;
  showCheck: boolean = false;

  getUrlParam: Function = getUrlParam;
  getActivityType: Function = getActivityType;
  needPayList: any = ['bargainType', 'groupType', 'lessonType', 'solitaireType', 'distributeType']; // 需要付款类型小麦秀
  checkType: string = '';

  @Watch('hasMaterialSaved')
  changeMaterial() {
    const aid = getUrlParam('aid');
    console.log('aid', aid);
    if (!this.hasMaterialSaved && !window.localStorage.getItem(`aid_${aid}`)) {
      this.showMaterailModal();
      window.localStorage.setItem(`aid_${aid}`, 'true');
    }
  }

  @Watch('wechatMiniOnlineStatus') 
  changeCheckModal() {
    if (window.localStorage.getItem('hasShowNotice')) {
      this.handleShowCheck();
    }
  }
  mounted() {
    if (getUrlParam('type') === 'edit'&&!window.localStorage.getItem('hasShowNotice')) {
      this.handleShowNotice();
    }

    // 链接上有uid为二级页面，没有则为一级页面

    // 统计一级活动页预览数
    if (!getUrlParam('uid')) {
      window.TDAPP.onEvent('一级活动页浏览数', ACTIVITY_TYPE[getActivityType()]);
    } else {
      // 统计二级页面浏览数
      window.TDAPP.onEvent('二级活动页浏览数', ACTIVITY_TYPE[getActivityType()]);
    }
  }

  handleShowNotice() {
    this.showNotice = true;
  }

  handleHideNotice() {
    this.showNotice = false;
    window.localStorage.setItem('hasShowNotice', 'true');
    this.handleShowCheck();
  }
  showMaterailModal() {
    this.showMaterial = true;
  }
  // 了解一下
  handleToKnow() {
    this.handleHiddenMaterail();
    window.location.href = 'https://mp.weixin.qq.com/s/TBG0LmyURVZoqdy90OzHEQ';
    // 通知B端改变链接去往如何使用活动素材页面
    parent.postMessage(
      {
        value: 'https://mp.weixin.qq.com/s/TBG0LmyURVZoqdy90OzHEQ',
        action: 'changeUrlAboutMaterial'
      },
      '*'
    );
  }
  handleHiddenMaterail() {
    this.showMaterial = false;
  }
  handleShowCheck() {
    if (getUrlParam('instId') && getUrlParam('enterType') === 'SCAN' && this.needPayList.indexOf(getActivityType()) > -1) {
      if (this.xmPayRegisterStatusEnum !== 'SUCCESS') {
        this.showCheck = true;
        this.checkType='xmPay'
      } else if(this.wechatMiniOnlineStatus !== 'AUTH_SUCCESS'){
        this.showCheck = true;
        this.checkType='weChat'
      }
    }
  }
  handleHideCheck() {
    this.showCheck = false;
  }
}
